'use client';
import { SimpleGrid, Center, Box, Button, Image, Text } from '@chakra-ui/react';
import { useRouter } from 'next/navigation';
import { useDispatch, useSelector } from 'react-redux'; // Import Redux's dispatch function
import { setStateValue } from '@/app/redux/slices/configGymSlice';
import { setDelCost } from '@/app/redux/slices/configBasketSlice';
import costsData from '/public/data/costs.json';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/pro-solid-svg-icons';
import {
  titleText,
  titleSubText,
  outerContainer,
  innerContainer,
  mainContainer,
  showTitle,
  showImgBox,
  showImg,
  showDesc,
  showDescLine,
  showPrice,
  priceGrid,
  priceText,
  pricePound,
  pricePounds,
  pricePence,
  showButton,
  selectedButton,
  buttonSelected,
  buttonSelect,
  buttonNext,
  buttonSelectGry,
  outerContainerText,
  innerContainerGrid,
  nextIconBox,
} from './styles';

export default function StdSizes() {
  const router = useRouter();
  const dispatch = useDispatch(); // Initialize dispatch from Redux
  const services = useSelector((state) => state.gym.survey);
  const isMobile = useSelector((state) => state.gym.isMobile);
  const serviceOpt = useSelector((state) => state.gym.serviceOpt);
  const isValid = useSelector((state) => state.gym.isValid);
  const isBackValid = useSelector((state) => state.gym.isBackValid);
  const isNextValid = useSelector((state) => state.gym.isNextValid);
  const isCheckoutValid = useSelector((state) => state.gym.isCheckoutValid);
  const salePrice = costsData.find((item) => item.name === 'sale');
  const Bpounds = Math.floor(salePrice.L); // Extracts the pound part
  const Bpence = (salePrice.L % 1).toFixed(2).substring(2); // Extracts the pence part

  const Spounds = Math.floor(salePrice.standard); // Extracts the pound part
  const Spence = (salePrice.standard % 1).toFixed(2).substring(2); // Extracts the pence part

  const Ppounds = Math.floor(salePrice.premium); // Extracts the pound part
  const Ppence = (salePrice.premium % 1).toFixed(2).substring(2); // Extracts the pence part

  const SVpounds = Math.floor(salePrice.survey); // Extracts the pound part
  const SVpence = (salePrice.survey % 1).toFixed(2).substring(2); // Extracts the pence part
  const iconSize = isMobile ? '6vw' : '1.5vw';
  const resetSurvey = () => {
    const resetServices = services.map((survey) => ({
      ...survey,
      selected: false,
      complete: false,
    }));
    dispatch(setStateValue({ key: 'survey', value: resetServices }));
    dispatch(setDelCost(35.0));
  };

  const handleSelect = (selected) => {
    dispatch(setStateValue({ key: 'serviceOpt', value: selected })); // Dispatch the selected package to Redux
    dispatch(setStateValue({ key: 'isCheckoutValid', value: false }));
    dispatch(setStateValue({ key: 'isNextValid', value: true }));
    // Scroll the page up to the git form
    if (selected == 'premium') {
      dispatch(setStateValue({ key: 'install', value: 'yes' }));
      dispatch(setStateValue({ key: 'progressOpt', value: 'Service' }));
      router.push('/contact');
    }
    if (selected == 'basic') {
      dispatch(setStateValue({ key: 'install', value: 'no' }));
      dispatch(setStateValue({ key: 'progressOpt', value: 'Mirrors' }));
      resetSurvey();
      router.push('/mirrors');
    }
    if (selected == 'standard') {
      dispatch(setStateValue({ key: 'install', value: 'yes' }));
      dispatch(setStateValue({ key: 'progressOpt', value: 'Mirrors' }));
      router.push('/mirrors');
    }
    if (selected == 'booking') {
      const updatedChoices = services.map((choice) => ({
        ...choice,
        selected: choice.type === 'paid',
        complete: choice.type === 'paid',
      }));
      dispatch(setStateValue({ key: 'survey', value: updatedChoices }));
      dispatch(setStateValue({ key: 'progressOpt', value: 'Booking' }));
      dispatch(setStateValue({ key: 'install', value: 'no' }));
      router.push('/booking');
    }
  };
  const handleNext = () => {
    dispatch(setStateValue({ key: 'progressOpt', value: 'Mirrors' }));
    router.push('/mirrors');
  };
  return (
    <>
      <Text {...titleText}>Select Your Service</Text>
      <Text {...titleSubText}>
        We offer a nationwide services to ensure a seamless experience for our
        clients.
      </Text>
      <Box {...outerContainer}>
        <SimpleGrid {...mainContainer}>
          <Box
            {...(isMobile ? innerContainerGrid : innerContainer)}
            border={
              serviceOpt == 'basic'
                ? '3px solid #0cc6de'
                : '1px solid #00000000'
            }
          >
            <Center {...showTitle}>Basic</Center>
            <Center {...showImgBox}>
              <Image
                {...showImg}
                src="images/gym/basic-icon.jpg"
                alt="Mirrorworld Basic Gym Mirror service"
              />
            </Center>
            <Box {...showDesc}>Mirror Only</Box>
            <Center {...showPrice}>
              <Box {...priceGrid}>
                {!isMobile && <Text {...priceText}>Starting</Text>}
                <Text {...pricePound}>£</Text>
                <Text {...pricePounds}>{Bpounds}</Text>
                <Text {...pricePence}>.{Bpence}</Text>
              </Box>
            </Center>
            <Center {...showButton}>
              <Button
                {...(serviceOpt === 'basic' ? buttonSelected : buttonSelect)}
                onClick={() => handleSelect('basic')}
              >
                {serviceOpt == 'basic' ? 'Selected' : 'Select'}
              </Button>
            </Center>
          </Box>
          <Box
            {...(isMobile ? innerContainerGrid : innerContainer)}
            border={
              serviceOpt == 'standard'
                ? '3px solid #0cc6de'
                : '1px solid #00000000'
            }
          >
            <Center {...showTitle}>Standard</Center>
            <Center {...showImgBox}>
              <Image
                {...showImg}
                src="/images/gym/standard-icon.jpg"
                alt="Mirrorworld Standard Gym Mirror service"
              />
            </Center>
            <Box {...showDesc} flexDirection={'column'}>
              <Text {...showDescLine}>White Glove Delivery</Text>
              <Text {...showDescLine}>Safety Backing</Text>
              <Text {...showDescLine}>Home Installation</Text>
            </Box>
            <Center {...showPrice}>
              <Box {...priceGrid}>
                {!isMobile && <Text {...priceText}>Starting</Text>}
                <Text {...pricePound}>£</Text>
                <Text {...pricePounds}>{Spounds}</Text>
                <Text {...pricePence}>.{Spence}</Text>
              </Box>
            </Center>
            <Center {...showButton}>
              <Button
                {...(serviceOpt === 'standard' ? buttonSelected : buttonSelect)}
                onClick={() => handleSelect('standard')}
              >
                {serviceOpt == 'standard' ? 'Selected' : 'Select'}
              </Button>
            </Center>
            <Center width="100%">
              <Box {...selectedButton}>Recommended</Box>
            </Center>
          </Box>
          <Box
            {...(isMobile ? innerContainerGrid : innerContainer)}
            border={
              serviceOpt == 'premium'
                ? '3px solid #0cc6de'
                : '1px solid #00000000'
            }
          >
            <Center {...showTitle}>Premium</Center>
            <Center {...showImgBox}>
              <Image
                {...showImg}
                src="images/gym/premium-icon.jpg"
                alt="Mirrorworld Platinum Gym Mirror service"
              />
            </Center>

            <Box {...showDesc}>
              Have us create and install a bespoke mirror to match existing
              décor, or something distinct and unique.
            </Box>
            <Center {...showPrice}>
              <Box {...priceGrid} alignItems="center">
                {!isMobile && <Text {...priceText}>Starting</Text>}
                <Text {...pricePound}>£</Text>
                <Text {...pricePounds}>{Ppounds}</Text>
                <Text {...pricePence}>.{Ppence}</Text>
              </Box>
            </Center>
            <Center {...showButton}>
              <Button
                {...buttonSelectGry}
                onClick={() => handleSelect('premium')}
              >
                Contact Us
              </Button>
            </Center>
          </Box>
          <Box
            {...(isMobile ? innerContainerGrid : innerContainer)}
            border={
              serviceOpt == 'booking'
                ? '3px solid #0cc6de'
                : '1px solid #00000000'
            }
          >
            <Center {...showTitle}>Survey</Center>
            <Center {...showImgBox}>
              <Image
                {...showImg}
                src="images/gym/survey-icon.jpg"
                alt="Mirrorworld Survey Gym Mirror service"
              />
            </Center>

            <Box {...showDesc}>
              Enjoy a hassle-free experience as we carry out a full site
              evaluation and ensure precise measurements.
            </Box>
            <Center {...showPrice}>
              <Box {...priceGrid} alignItems="center">
                {!isMobile && <Text {...priceText}>Starting</Text>}
                <Text {...pricePound}>£</Text>
                <Text {...pricePounds}>{SVpounds}</Text>
                <Text {...pricePence}>.{SVpence}</Text>
              </Box>
            </Center>
            <Center {...showButton}>
              <Button
                {...(serviceOpt === 'booking' ? buttonSelected : buttonSelect)}
                onClick={() => handleSelect('booking')}
              >
                {serviceOpt == 'booking' ? 'Selected' : 'Select'}
              </Button>
            </Center>
          </Box>
        </SimpleGrid>
        <Center {...outerContainerText}>
          Service fees may vary based on order quantity due to the additional
          time required for installation
        </Center>
        {/*     ##### Navigation ######    */}
        <Box display="flex" justifyContent="end">
          <Button
            {...buttonNext}
            onClick={handleNext}
            isDisabled={serviceOpt === 'none'}
            sx={{
              ...(serviceOpt !== 'none'
                ? {}
                : {
                    backgroundColor: 'gray.300', // Greyed-out background
                    color: 'gray.500', // Greyed-out text color
                    cursor: 'not-allowed', // Disabled cursor
                  }),
            }}
          >
            <Box flex="1" textAlign="center">
              {serviceOpt === 'booking' ? 'Booking' : 'Mirrors'}
            </Box>
            <Box {...nextIconBox}>
              <FontAwesomeIcon icon={faAngleRight} fontSize={iconSize} />
            </Box>
          </Button>
        </Box>
      </Box>
    </>
  );
}
